import { ConsentStatus, CONSENT_STATUS, SubscriptionsResponse } from './types';
export interface State {
    subscriptions: SubscriptionsResponse;
    consentStatus: ConsentStatus;
    subscriptionLoading: boolean;
    consentLoading: boolean;
    subscriptionPending: boolean;
    errorCount: number;
    error: boolean;
    newlySubscribed: boolean;
}

export const initialState: State = {
    subscriptions: { daily: false, weekly: false },
    consentStatus: CONSENT_STATUS.ABSENT,
    subscriptionLoading: false,
    consentLoading: false,
    subscriptionPending: false,
    errorCount: 0,
    error: false,
    newlySubscribed: false,
};
